import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import React, { useEffect } from "react";
import Cookies from "js-cookie";

const RememberMe = ({ setRememberMe, rememberMe }) => {
  useEffect(() => {
    Cookies.get("email");
    Cookies.get("password");
    const storedRememberMe = Cookies.get("rememberMe");

    if (storedRememberMe === "true") {
      setRememberMe(true);
    }
  }, []);

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
        }
        label="Remember me"
      />
    </FormGroup>
  );
};

export default RememberMe;
